const data = {
  "salesPriceCurrent": {
    "from": "Vanaf",
    "excludingVAT": "excl. btw",
    "excludingVATperItem": "excl. btw per st.",
    "perItem": "per st.",
    "perMonth": "per maand",
    "perMonthShort": "p/m",
    "free": "Gratis"
  },
  "salesPriceLabel": {
    "subscription": "of <linkComponent><priceComponent/> per maand</linkComponent>",
    "oneTimePayment": "+ <priceComponent/> eenmalige kosten"
  },
  "personalPrice": {
    "label": "{{discountText}} toegepast"
  }
};

export default data;